import React, { useState, useEffect } from "react";
import { MDBRow, MDBCol, MDBInput, MDBBtn, MDBContainer } from "mdbreact";

import Axios from "axios";

import "react-datepicker/dist/react-datepicker.css";

import WarningBox from "../components/WarningBox";

import Select from "react-select";
import Spinner from "../components/Spinner";
import { Bounce, ToastContainer, toast } from "react-toastify";

const CustomerInformation = (props) => {
  const useMountEffect = (functionName) => useEffect(functionName, []);
  const serverURL = props.apiServer;

  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };
  const [showPreloader, setPreloader] = useState("normal");
  const [frm, setValues] = useState({
    code: "new",
    lastname: "",
    firstname: "",
    middlename: "",
    nameext: "",
    mobilenumber: "",
    address: "NOT SPECIFIED",

    deleted: false,
    datecreated: new Date(),
    usercode: sessionStorage.getItem("Email"),
    usertoken: sessionStorage.getItem("msal.uc"),
  });

  const updateField = (e) => {
    const target = e.target;

    let value = target.value;
    let name = target.id;

    if (target.type === "checkbox") {
      value = target.checked;

      setValues({ ...frm, [name]: value });
    } else {
      setValues({ ...frm, [name]: value });
    }
  };

  const handleChange = (objName) => (selOption) => {
    setValues({ ...frm, [objName]: selOption });
  };

  function submitHandler(event) {
    event.preventDefault();
    event.target.className += " was-validated";

    savecustomer();
  }

  const [errorMessage, setErrorMessage] = useState("");

  const [modalWarning, showWarningBox] = useState(false);

  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  };

  const loadcustomerdetails = () => {
    setPreloader("normal");
    Axios.get(
      props.apiServer +
        "/loadcustomerinformation?acode=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        if (res.data !== "empty") {
          setValues({
            ...frm,
            code: sessionStorage.getItem("Email"),

            lastname: res.data.lastname,
            firstname: res.data.firstname,
            middlename: res.data.middlename,
            nameext: res.data.nameext,
            mobilenumber: res.data.mobilenumber,
            address: res.data.address,
            usercode: res.data.usercode,
            deleted: res.data.deleted,
          });
          setPreloader("none");
        } else {
          console.log("No record");
        }
      })

      .catch((error) => {
        setErrorMessage(error);
        // toggleWarningBox();
        setPreloader("none");
        console.log(error);
      });
    setPreloader("none");
  };

  const toastId = React.useRef(null);

  const notify = (message) => {
    toast(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold blue-text",
    });
  };

  const warning = (message) => {
    toast.error(() => message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      transition: Bounce,
      className: "font-weight-bold white-text",
    });
  };
  const savecustomer = () => {
    const data = frm;
    setPreloader("normal");
    Axios.post(props.apiServer + "/savecustomer", data, bearer)
      .then((res) => {
        if (res.data.status === "1") {
          setValues({ ...frm, code: res.data.code });

          notify(res.data.message);

          setPreloader("none");
        } else {
          warning(res.data.message);
          setPreloader("none");
        }
      })
      .catch((error) => {
        warning(res.data.message);
        setPreloader("none");
      });
  };

  useMountEffect(loadcustomerdetails);

  return (
    <React.Fragment>
      {showPreloader === "normal" ? (
        <Spinner />
      ) : (
        <MDBContainer fluid>
          <MDBRow>
            <MDBCol md="10">
              <form
                className="needs-validation"
                onSubmit={submitHandler}
                noValidate
              >
                <MDBRow hidden>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.code}
                      id="code"
                      label="code"
                      required
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.lastname}
                      id="lastname"
                      label="Last Name"
                      required
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>

                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.firstname}
                      id="firstname"
                      label="First Name"
                      onChange={updateField}
                      required
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.middlename}
                      id="middlename"
                      label="Middle Name"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.nameext}
                      id="nameext"
                      label="Name Ext"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.mobilenumber}
                      id="mobilenumber"
                      label="Mobile Number"
                      onChange={updateField}
                      required
                    ></MDBInput>
                    <div className="invalid-feedback">
                      This field is required!
                    </div>
                    <div className="valid-feedback"></div>
                  </MDBCol>
                </MDBRow>
                {/* <MDBRow>
                  <MDBCol md="10">
                    <MDBInput
                      value={frm.address}
                      id="address"
                      label="Address"
                      onChange={updateField}
                    ></MDBInput>
                  </MDBCol>
                </MDBRow> */}

                <MDBRow style={{ display: "none" }}>
                  <MDBCol md="12">
                    <MDBInput
                      id="deleted"
                      label="Is Deleted"
                      type="checkbox"
                      checked={frm.deleted}
                      onChange={updateField}
                    >
                      <div className="invalid-feedback">
                        This field is required!
                      </div>
                      <div className="valid-feedback"></div>
                    </MDBInput>
                  </MDBCol>
                </MDBRow>
                <MDBRow>
                  <MDBCol md="12">
                    <MDBBtn className="blue lighten-1" type="submit">
                      Save
                    </MDBBtn>
                    {props.quicktool === "yes" ? (
                      <>
                        <MDBBtn
                          id="cmdClose"
                          className="blue lighten-4 blue-text"
                          onClick={props.toggleModal}
                        >
                          Close this
                        </MDBBtn>
                        <MDBBtn
                          id="cmdClose"
                          className="orange lighten-4 black-text"
                          onClick={props.toggleModal2}
                        >
                          Back to Customer Ticket
                        </MDBBtn>
                      </>
                    ) : (
                      ""
                    )}
                    {props.quickadd === "yes" ? (
                      <>
                        <MDBBtn
                          id="cmdClose"
                          className="blue lighten-4 blue-text"
                          onClick={props.toggleModal2}
                        >
                          Close this
                        </MDBBtn>
                      </>
                    ) : (
                      ""
                    )}

                    {/* {props.code === "" ? (
                    <MDBBtn
                      id="cmdClose"
                      className="blue lighten-4 blue-text"
                      onClick={props.toggleModal}
                    >
                      Close
                    </MDBBtn>
                  ) : (
                    ""
                  )} */}
                  </MDBCol>
                  <MDBCol md="6"></MDBCol>
                </MDBRow>
              </form>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      )}

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Bounce}
      ></ToastContainer>

      <WarningBox
        errorMessage={errorMessage}
        isOpen={modalWarning}
        toggleModal={toggleWarningBox}
      />
      {/* <MessagePersonalInfo /> */}
    </React.Fragment>
  );
};
export default CustomerInformation;
